<template>
    <div class="m-editFiscanPaper">
        <div v-if="!paperData.length" class="manual-no-topic">
            <el-empty description="当前试卷没有任何题目">
                <el-button @click="openSelector" type="primary">添加题目</el-button>
            </el-empty>
        </div>

        <div v-if="paperData.length" class="paper-container">
            <aside class="paper-aside">
                <sticky :stickyTop="130" scroller=".sub-page .el-main">
                    <div class="paper-aside-wrap">
                        <div class="paper-aside-box category">
                            <p>题目数量：{{ count.num }} {{ $t('paper.dao') }}</p>
                            <p>{{ $t('paper.eachTopic') }}：
                                <el-input-number
                                    v-model="score" size="mini" :min="1" :max="50"></el-input-number>
                                {{ $t('paper.points') }}
                            </p>
                            <p>{{ $t('paper.totalScores') }}：{{ count.total }} {{ $t('paper.points') }}</p>
                            <p>{{ $t('paper.passScore') }}：{{ count.pass }} {{ $t('paper.points') }}</p>
                        </div>

                        <div class="btn-group btn-aside">
                            <el-button class="btn-other" @click="openSelector" type="primary" plain>
                                <i class="nucfont inuc-add-circle"></i>
                                {{ $t('paper.addTopic') }}
                            </el-button>

                            <el-button class="btn-other" @click="previewPaper" type="primary" plain>
                                <i class="nucfont inuc-preview"></i>
                                {{ $t('paper.previewPaper') }}
                            </el-button>

                            <el-button type="primary"
                                       class="btn-submit"
                                       @click="submitPaper"
                                       :loading="submitLoading"
                                       :disabled="!paperData.length">
                                <i class="nucfont inuc-step-right"></i>
                                {{ $t('paper.savePaper') }}
                            </el-button>
                        </div>
                    </div>
                </sticky>
            </aside>

            <ul class="paper-list">
                <li class="paper-item" v-for="(item, index) in paperData" :key="index">
                    <div class="image-wrap">
                        <img :src="item.url" alt="image" @click="viewImageDetail(item)">
                    </div>
                    <div class="image-des">
                        <p class="image-type">【<span class="type-name">{{item.typeName}}</span> , <span
                            class="type-name">{{item.number}}</span>】</p>
                        <div class="basic-info">
                            <template v-if="item.image">
                                <p>物品名称：{{item.image.name}}</p>
                                <p>采集设备：{{item.image.productName}}</p>
<!--                                <p>职业技能鉴定：{{item.image.isIdentification ? '是': '否'}}</p>-->
                            </template>
                            <p>{{$t('c.knowledgePoint')}}：{{item.knowledgeName}}</p>
                            <p>{{$t('c.operatorLevel')}}：{{item.forLevelName}}</p>
                            <p>{{$t('c.difficulty')}}：{{item.difficultyName}}</p>
                            <p>{{$t('topic.papersAssembled')}}：{{item.usageCount}}</p>
                            <p>{{$t('paper.accuracyRate')}}：{{item.accuracy!=-1?(Math.round(item.accuracy * 10000) /
                                100 + '%'):'--'}}</p>
                        </div>
                        <div class="goods-info" v-if="item.marks.length">
                            <el-tag v-for="(v, i) in item.marks" :key="i" type="danger" size="small">{{v.knowledgeName}}</el-tag>
                        </div>
                    </div>
                    <div class="btn-operate">
                        <a class="btn-edit" @click="keyTopic(index)" :title="$t('paper.keyQuestion')">
                            <i class="nucfont inuc-favor" :class="{'inuc-favor-fill': item.isKey}"></i></a>
                        <a class="btn-edit" @click="viewImageDetail(item)" :title="$t('c.view')">
                            <i class="nucfont inuc-preview"></i></a>
                        <el-popconfirm :title="$t('m.delete')" @confirm="deleteTopic(index)">
                            <a class="btn-delete" :title="$t('c.delete')" slot="reference">
                                <i class="nucfont inuc-delete"></i>
                            </a>
                        </el-popconfirm>
                    </div>
                </li>
            </ul>
        </div>

        <fiscan-image-selector v-model="selectorDialog" @on-save="onSelectorSave" />

        <fiscan-detail
            ref="fiscanDetail"
            class="fiscan-detail"
            :isBag="true"
            :subPage.sync="imageViewer"
            :show-switch-button="false"
        />

        <el-backtop target=".sub-page .el-main"></el-backtop>

        <transition enter-active-class="animated slideInRight"
                    leave-active-class="animated slideOutRight">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
import FiscanImageSelector from "./FiscanImageSelector";
import FiscanDetail from "@/pages/MapManage/FiscanDetail";
import Sticky from '@/components/Sticky'
import {screenfull, Ticket} from "@/utils";

export default {
    name: 'EditFiscanPaper',

    props: {
        formData: Object,     // 第一阶段的表单
        paperDetail: Object   // 考卷详情数据
    },

    components: {
        FiscanImageSelector,
        FiscanDetail,
        Sticky,
    },

    data() {
        return {
            paperData: [],
            score: 0,
            submitLoading: false,
            selectorDialog: false,
            imageViewer: false,
            listData: []
        }
    },

    computed: {
        count() {
            let obj = {
                num: this.paperData.length,
                total: 0,
                pass: 0
            }

            obj.total = (this.score * obj.num).toFixed(2)
            obj.pass = (obj.total * this.paperDetail.passLine).toFixed(2)

            return obj
        },
        paperDataIds() {
            if (this.paperData.length) {
                return this.paperData.map(item => item.id)
            }
            return []
        },
    },

    mounted() {
        this.fillData()
    },

    methods: {
        // 填充考卷信息
        fillData() {
            let data = [...this.paperDetail.relationship]

            data.forEach((val, index) => {
                this.paperData.push(val.topic)
                this.$set(this.paperData[index], 'isKey', val.key)

                // 加载分数
                this.score = val.score
            })
        },

        // 图像选择器
        openSelector() {
            this.selectorDialog = true
        },
        onSelectorSave(data) {
            this.paperData = this.paperData.concat(data)
        },

        keyTopic(index) {
            this.$set(this.paperData[index], 'isKey', !this.paperData[index].isKey)
        },

        deleteTopic(index) {
            this.paperData.splice(index, 1)
        },

        formatPaper() {
            const knowledgeArr = this.formData.knowledge

            let submitData = {
                ...this.formData,
                knowledge: knowledgeArr[knowledgeArr.length-1],
                relationship: []
            }

            submitData.relationship = this.paperData.map(val => {
                return {
                    topicID: val.id,
                    score: this.score,
                    key: val.isKey
                }
            })

            return submitData
        },

        viewImageDetail({packageId}) {
            this.$refs.fiscanDetail.getImageDetail(packageId);

            this.imageViewer = true
        },

        previewPaper() {
            let previewData = this.formatPaper()

            Object.assign(previewData, {
                totalScore: this.count.total,
                passScore: this.count.pass,
                score: this.score,
            })

            previewData.relationship.forEach(item => {
                item.topic = this.paperData.find(v => v.id == item.topicID)
            })

            this.$router.push({name: 'editFiscanPaperPreview', params: {data: previewData}, query: {isFiscan: true}})
            screenfull.request()
        },

        submitPaper() {
            let submitData = this.formatPaper()

            this.submitLoading = true

            this.$api.putPaper(this.paperDetail.id, submitData).then(res => {
                this.$notify.success({
                    title: this.$t('c.success'),
                    message: this.$t('paper.editPaperSuccess'),
                    type: 'success',
                    duration: 2000
                })
                this.$emit('needUpdate')
                this.$router.replace({name: 'myPaper'})
            }).finally(() => this.submitLoading = false)
        }
    },
}
</script>

<style lang="scss">
.m-editFiscanPaper {

    .paper-list {
        .paper-item {
            position: relative;
            display: flex;
            margin-bottom: 20px;
            padding: 15px 20px;
            font-size: 12px;
            background-color: #f3f8ff;
            border-radius: 8px;
        }

        .image-wrap {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 320px;
            height: 240px;
            background-color: #fff;

            img {
                cursor: pointer;
                max-height: 100%;
            }
        }

        .image-des {
            flex: 1;
            margin-left: 50px;
            height: 100%;
            padding-top: 5px;

            .image-type {
                margin-bottom: 10px;

                .type-name {
                    padding: 2px;
                    color: #ff4081;
                }
            }

            .basic-info {
                padding-left: 8px;
                p {
                    margin-bottom: 8px;
                }
            }

            .goods-info {
                margin-top: 10px;
            }
        }

        .btn-operate {
            position: absolute;
            right: 12px;
            top: 18px;

            a {
                display: inline-block;
                margin-right: 9px;
                cursor: pointer;
                color: #999;

                .nucfont {
                    font-size: 18px;
                }

                &.btn-edit:hover,
                .inuc-favor-fill {
                    color: $color-theme;
                }

                &.btn-delete:hover {
                    color: $c-danger;
                }
            }
        }
    }

    // 图片查看页
    .fiscan-detail {
        .image-wrap {
            position: relative;
            height: calc(100vh - 230px);
        }
        .image-operate {
            @include media-1680 {
                transform: translateY(-50%) scale(0.8);
                right: 10px;
            }
        }
    }
}

</style>
